import { render, staticRenderFns } from "./PaginatedDataTable.vue?vue&type=template&id=ed5f2fb6&"
import script from "./PaginatedDataTable.vue?vue&type=script&lang=js&"
export * from "./PaginatedDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports